import styled from 'styled-components';

// TODO: import BodyCopySmall from CommonUI

export const TooltipContentWrapper = styled.div`
	font-size: 13px;
	font-weight: 500;
	line-height: 1.4em;
	text-transform: none;
`;

export const TooltipContentTitle = styled.label`
	font-weight: 700;
`;
